<ng-container *transloco="let t">
  <div #facebookButton class="facebook-button" (click)="facebookLogin()">
    <div class="flex-row h-100 w-100" style="align-items: center;">
      <mat-icon style="margin-right: 24px;">facebook</mat-icon>
      <span>{{ t('GENERIC_WRAPPER.SIGN_IN_WITH_FACEBOOK')}}</span>
    </div>
  </div>
</ng-container>
